<template>
  <div>
    <h3 class="mt-3 mb-3">
      {{ $t('defaultServiceValues.cityAndContractType') }}
    </h3>

    <p class="mb-5" v-if="!showDefaultValuesForm">
      {{ $t('defaultServiceValues.hints.cityAndContractType') }}
    </p>

    <v-select
      @change="updateDefaultValues($event.value, 'contract_type')"
      :disabled="showDefaultValuesForm"
      :label="$t('defaultServiceValues.label.contractType')"
      :no-data-text="$t('appointment.filters.noData')"
      :items="paymentTypes"
      :item-text="({ value }) => $t(`paymentTypes.${value}`)"
      item-value="value"
      hide-details="auto"
      class="mb-5"
      return-object
      single-line
      outlined
    />

    <v-autocomplete
      @keyup="setCitySearch"
      @change="updateDefaultValues($event.id, 'city_id')"
      :disabled="showDefaultValuesForm"
      :label="$t('defaultServiceValues.label.city')"
      :no-data-text="$t('appointment.filters.noData')"
      :loading="cityLoading"
      :items="cities"
      item-text="name"
      item-value="id"
      return-object
      hide-no-data
      clearable
      outlined
    >
      <template v-slot:selection="data">
        {{ data.item.name }}/{{ data.item.state.acronym }}
      </template>
      <template v-slot:item="data">
        {{ data.item.name }}/{{ data.item.state.acronym }}
      </template>
    </v-autocomplete>

    <div class="text-right">
      <v-btn
        v-if="!showDefaultValuesForm"
        @click="setShowDefaultValuesForm(true)"
        :disabled="!defaultServiceValuesFields.contract_type"
        elevation="0"
        color="primary"
        large
      >
        {{
          defaultServiceValuesFields.city_id
            ? $t('defaultServiceValues.actions.continueWithSelectedCity')
            : $t('defaultServiceValues.actions.continueWithoutCity')
        }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { paymentTypes } from '@/config/constants'

export default {
  name: 'ContractTypeAndCity',

  data() {
    return {
      _timer: null,
      search: null,
      cityLoading: false,
      paymentTypes,
    }
  },

  computed: {
    ...mapGetters([
      'cities',
      'defaultServiceValuesFields',
      'showDefaultValuesForm',
    ]),
  },

  methods: {
    ...mapActions(['fetchCitiesPaginated']),
    ...mapMutations([
      'setShowDefaultValuesForm',
      'setDefaultServiceValuesFields',
    ]),

    updateDefaultValues(value, field) {
      this.setDefaultServiceValuesFields({ [field]: value })
    },

    setCitySearch({ target }) {
      clearTimeout(this._timer)

      this._timer = setTimeout(() => {
        if (target.value && target.value.length >= 3) {
          this.cityLoading = true
          this.fetchCitiesPaginated(target.value).finally(() => (this.cityLoading = false))
        }
      }, 500)
    },
  },
}
</script>
